module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "pref02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("MAPS AND FIGURES")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/pref07#pref07fig01"
    }
  }, [_vm._v("Antarctica, physical and political, 1955–1975")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch00a#ch00afig01"
    }
  }, [_vm._v("Territorial claims")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch01#ch01fig01"
    }
  }, [_vm._v("IGY stations in Antarctica")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ross Island, Antarctica")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hut Point Peninsula and ice runway sites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch09#ch09fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antarctic mother-daughter weather communication network")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Over-snow traverse routes of the IGY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030e5752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pref02.vue
// module id = 78
// module chunks = 0